<template>
  <div class="h-full w-full px-2">
    <template v-if="genre.id">
      <genre-place-list
        @openPlace="onOpenPlace"
        :genre="genre"
      />
    </template>
    <template v-else>
      <div class="mb-2 text-right">
        <a @click="$emit('openGenreList')" class="flex items-center justify-end text-link text-sm">
          {{ $t('tour_genre_list_link') }}
          <svg enable-background="new 0 0 20 20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="pl-1 h-5"><path clip-rule="evenodd" d="m8.9 5.2 4.4 4.4c.2.2.2.5 0 .7l-4.4 4.4c-.2.2-.5.2-.7 0-.1 0-.2-.1-.2-.3v-8.9c0-.3.2-.5.5-.5.1.1.3.1.4.2z" fill-rule="evenodd" /></svg>
        </a>
      </div>
      <template v-if="searchWord.length > 0">
        <search-result
          :searchWord="searchWord"
          @selectGenre="onSelectGenre"
          @openPlace="onOpenPlace"
        />
      </template>
      <template v-else>
        <history @openPlace="onOpenPlace" />
      </template>
    </template>
  </div>
</template>

<script>
import History from './History'
import SearchResult from './SearchResult'
import GenrePlaceList from './GenrePlaceList'

export default {
  components: {
    History,
    SearchResult,
    GenrePlaceList,
  },
  props: {
    genre: {
      type: Object,
      required: true
    },
    searchWord: {
      type: String,
      required: true
    }
  },
  methods: {
    onSelectGenre: function (genre) {
      this.$emit('selectGenre', genre)
    },
    onOpenPlace: function (place) {
      this.$emit('selectGenre', {})
      if (place.isGooglePlace) {
        this.$store.dispatch('map/updateGooglePlaceMarker', place)
      }
      this.$store.dispatch('drawer/openPlace', { place: place, full: true })
    }
  }
}
</script>
